/**
 * Gizlilik Politikasi ve KVKK Aydinlatma Metni
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft, Baby, Shield } from 'lucide-react';

const COMPANY_NAME = "KONSULTAN OZEL SAGLIK HIZMETLERI GIDA HAYV. TURZ. SAN. VE TIC. LTD. STI.";

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50">
      <header className="bg-white/80 backdrop-blur border-b sticky top-0 z-10">
        <div className="container mx-auto px-4 py-3 flex items-center gap-4">
          <Button data-testid="back-button" variant="ghost" size="sm" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-4 h-4 mr-1" />
            Geri
          </Button>
          <div className="flex items-center gap-2">
            <Baby className="w-6 h-6 text-pink-500" />
            <span className="font-bold text-slate-800">BabyFace AI</span>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-8 max-w-3xl">
        <div className="bg-white rounded-2xl shadow-sm border p-6 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <Shield className="w-8 h-8 text-pink-500" />
            <h1 data-testid="privacy-title" className="text-2xl md:text-3xl font-bold text-slate-800">
              Gizlilik Politikasi ve KVKK Aydinlatma Metni
            </h1>
          </div>

          <p className="text-sm text-slate-400 mb-6">Son guncelleme: 25 Mart 2026</p>

          <div className="prose prose-slate max-w-none text-sm leading-relaxed space-y-6">
            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">1. Veri Sorumlusu</h2>
              <p className="text-slate-600">
                6698 sayili Kisisel Verilerin Korunmasi Kanunu ("KVKK") kapsaminda veri sorumlusu 
                <strong> {COMPANY_NAME}</strong>'dir.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">2. Toplanan Kisisel Veriler</h2>
              <ul className="list-disc pl-5 text-slate-600 space-y-1">
                <li><strong>Kimlik Bilgileri:</strong> Ad, soyad, e-posta adresi</li>
                <li><strong>Iletisim Bilgileri:</strong> Telefon numarasi</li>
                <li><strong>Saglik Bilgileri:</strong> Gebelik haftasi, ultrason goruntuleri</li>
                <li><strong>Islem Bilgileri:</strong> Kredi satin alma ve kullanim gecmisi</li>
                <li><strong>Teknik Bilgiler:</strong> IP adresi, tarayici bilgileri, cerez verileri</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">3. Verilerin Islenmesi Amaci</h2>
              <ul className="list-disc pl-5 text-slate-600 space-y-1">
                <li>Hizmetin sunulmasi ve iyilestirilmesi</li>
                <li>Kullanici hesabinin olusturulmasi ve yonetilmesi</li>
                <li>Odeme islemlerinin gerceklestirilmesi</li>
                <li>Yapay zeka modelleriyle gorsel uretimi</li>
                <li>Yasal yukumluluklerin yerine getirilmesi</li>
                <li>Iletisim ve destek hizmetleri</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">4. Verilerin Aktarimi</h2>
              <p className="text-slate-600">
                Kisisel verileriniz, yalnizca hizmetin sunulmasi icin gerekli olan durumlarda 
                ve KVKK'nin 8. ve 9. maddeleri kapsaminda ucuncu taraflara aktarilabilir:
              </p>
              <ul className="list-disc pl-5 text-slate-600 space-y-1">
                <li>Odeme hizmeti saglayicilari (sifrelenmis odeme bilgileri)</li>
                <li>Bulut altyapi saglayicilari (sifrelenmis veri depolama)</li>
                <li>Yasal yetkililer (yasal zorunluluk halinde)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">5. Ultrason Goruntulerinin Islenmesi</h2>
              <p className="text-slate-600">
                Yuklediginiz ultrason goruntuleri ozel saglik verisi niteligindedir. Bu goruntuler:
              </p>
              <ul className="list-disc pl-5 text-slate-600 space-y-1">
                <li>Sifrelenerek guvenli sunucularda saklanir</li>
                <li>Yalnizca AI gorsel uretimi icin islenir</li>
                <li>Ucuncu taraflarla paylasilmaz</li>
                <li>Kullanici talep ettiginde kalici olarak silinir</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">6. Veri Sahibinin Haklari</h2>
              <p className="text-slate-600">KVKK'nin 11. maddesi uyarinca asagidaki haklara sahipsiniz:</p>
              <ul className="list-disc pl-5 text-slate-600 space-y-1">
                <li>Kisisel verilerinizin islenip islenmedigini ogrenme</li>
                <li>Islenmisse buna iliskin bilgi talep etme</li>
                <li>Isleme amacini ve amacina uygun kullanilip kullanilmadigini ogrenme</li>
                <li>Aktarilmissa ucuncu kisileri bilme</li>
                <li>Eksik veya yanlis islenmisse duzeltilmesini isteme</li>
                <li>KVKK'nin 7. maddesinde ongOrulen sartlar cercevesinde silinmesini isteme</li>
                <li>Islenen verilerin sadece otomatik sistemler araciligiyla analiz edilmesi sonucu aleyhinize cikan sonuca itiraz etme</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">7. Cerez Politikasi</h2>
              <p className="text-slate-600">
                Platformumuz, hizmet kalitesini artirmak icin cerezler kullanmaktadir. 
                Zorunlu cerezler disindaki cerezler icin ayri onay alinmaktadir.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mb-2">8. Veri Guevenligi</h2>
              <p className="text-slate-600">
                Kisisel verilerinizin guvenligini saglamak icin 256-bit SSL sifreleme, 
                guvenli sunucu altyapisi ve duzenli guvenlik denetimleri uygulanmaktadir.
              </p>
            </section>

            <section className="bg-slate-50 rounded-lg p-4 mt-8">
              <h2 className="text-lg font-semibold text-slate-800 mb-2">Iletisim</h2>
              <p className="text-slate-600">
                KVKK kapsamindaki talepleriniz icin:<br />
                <strong>Veri Sorumlusu:</strong> {COMPANY_NAME}<br />
                <strong>E-posta:</strong> kvkk@babyface.ai
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicyPage;
